<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
                        <div class="row">
                            <div class="col-md-3">
                                <h2 class="text-white pb-2 fw-bold">Data Produksi Beras Tahun 2019</h2>
                                <h5 class="text-white op-7 mb-2">Jumlah Penduduk : 310988 / Konsumsi Kg/Kap/Th : 98.6 </h5>
                            </div>
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="col-md-6">
                                        <select @change="getProduksi()" class="form-control" v-model="form.master_komoditi_id">
                                            <option v-for="data in list_master_komoditi_id" :key="data.master_komoditi_id" :value="data.master_komoditi_id">Data Produksi {{data.uraian}}</option>
                                        </select>
                                        <br>
                                    </div>
                                    <div class="col-md-6">
                                        <select @change="getTahun()" class="form-control" v-model="form.thn">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select>
                                        <br>
                                    </div>
                                    <div class="col-md-6">
                                        <autocomplete
                                            :url="URL+ 'api/v1/statistik_ketapang_master_kecamatan/autocomplete'"
                                            :customHeaders="{authorization: 'kikensbatara '+token }"
                                            anchor="nama_kecamatan"
                                            :initValue="''"
                                            :placeholder="'Cari Kecamatan'"
                                            :classes="{ input: 'form-control'}"
                                            label="writer"
                                            :onShouldRenderChild="renderChild"
                                            :on-select="getAuto">
                                        </autocomplete> <br>
                                        <br>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="input-group" >
                                                <select @change="getBln()" class="form-control  form-control-sm" v-model="form.bln">
                                                    <option v-for="data in list_bln" :key="data.id" :value="data.id">{{data.uraian}}</option>
                                                </select>
                                                <br>
                                                <div class="input-group-append">
                                                    <button v-if="!cek_disabled" @click="Chk_Add()" class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
                                                    <button v-if="cek_disabled" @click="Chk_Add()" class="btn btn-warning" type="button" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-marker"></i></button>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">


                        <table class="table-kiken table table-head-bg-info" width="100%" >
                            <thead>
                                <tr class="bg-primary">
                                    <th scope="col" style="width: 5%">No</th>

									<th scope="col" style="width: 50%">Uraian</th>
                                    <th scope="col" style="width: 45%">Value</th>
                                    <!-- <th scope="col" style="width: 15%"></th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="cek_load_data">
                                    <td colspan="9" class="text-center">
                                        <img src="img/loading-plan.gif" width="450px">
                                    </td>
                                </tr>
                                <template >
                                <!-- <template v-if="!cek_load_data" > -->
                                    <tr class="h_isitable">
                                        <td class="text-center">1</td>
                                        <td >Produksi Kotor Padi (Ton)</td>
                                        <td >{{object_data.produksi_kotor}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">2</td>
                                        <td >Benih ({{object_data.Pengeluaran_GKG_benih}}%)</td>
                                        <td >{{produksi_final(object_data).Pengeluaran_GKG_benih}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">3</td>
                                        <td >Pakan Ternak ({{object_data.Pengeluaran_GKG_pakan_ternak}}%)</td>
                                        <td >{{produksi_final(object_data).Pengeluaran_GKG_pakan_ternak}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">4</td>
                                        <td >Susut/Tercecer ({{object_data.Pengeluaran_GKG_susut}}%)</td>
                                        <td >{{produksi_final(object_data).Pengeluaran_GKG_susut}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">5</td>
                                        <td >BBI Non Makanan ({{object_data.Pengeluaran_GKG_BBI}}%)</td>
                                        <td >{{produksi_final(object_data).Pengeluaran_GKG_BBI}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">6</td>
                                        <td >Pakan Ternak ({{object_data.Penggunaan_Bersa_pakan_ternak}}%)</td>
                                        <td >{{produksi_final(object_data).Penggunaan_Bersa_pakan_ternak}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">7</td>
                                        <td >Industri Non Makanan ({{object_data.Penggunaan_Bersa_industri_nm}}%)</td>
                                        <td >{{produksi_final(object_data).Penggunaan_Bersa_industri_nm}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">8</td>
                                        <td >Tercecer/Susut ({{object_data.Penggunaan_Bersa_susut}}%)</td>
                                        <td >{{produksi_final(object_data).Penggunaan_Bersa_susut}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">9</td>
                                        <td >Produksi Padi (Ton GKG)</td>
                                        <td >{{produksi_final(object_data).produksi_GKG}}</td>
                                    </tr>
                                    <tr class="h_isitable">
                                        <td class="text-center">10</td>
                                        <td >Produksi Bersih Beras ({{object_data.bersih}}%)</td>
                                        <td >{{produksi_final(object_data).produksi_bersih}}</td>
                                    </tr>
                            
                                </template>
                                    <tr class="h_isitable">
                                        <td colspan="3">
                                            <span>Jumlah Penduduk   : <b>{{object_data.jml_penduduk}}</b></span> <br>
                                            <span>Konsumsi Kg/Kap/Th : <b>{{object_data.konsumsi}}</b> </span>
                                        </td>
                                    </tr>


                            </tbody>
                        </table>

                        <!-- <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <img src="assets/img/sf/sign-left.svg" height="24" width="24">
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <img src="assets/img/sf/sign-right.svg" height="24" width="24">
                                </button>
                            </div>
                        <hr> -->
					</div>
				</div>

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <div v-if="cek_Add">
                                            <span class="huruf_input">Produksi Kotor Padi (Ton)</span>
                                            <input v-model="form.produksi_kotor" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                            
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Jumlah Penduduk</span>
                                                    <input v-model="form.jml_penduduk" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                                </div>
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Konsumsi Kg/Kap/Th</span>
                                                    <input v-model="form.konsumsi" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                                </div>
                                            </div>
                                            <hr>
                                        
                                        
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                        <div v-if="!cek_Add" class="text-center">
                                            <h3><b>PILIH KECAMATAN TERLEBIH DAHULU</b></h3>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="cek_Add" type="submit" class="btn bgcol-info btn-md">SIMPAN</button>
                                        <button type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div>
                                            <span class="huruf_input">Produksi Kotor Padi (Ton)</span>
                                            <input v-model="form.produksi_kotor" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                            
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Jumlah Penduduk</span>
                                                    <input v-model="form.jml_penduduk" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                                </div>
                                                <div class="col-md-6">
                                                    <span class="huruf_input">Konsumsi Kg/Kap/Th</span>
                                                    <input v-model="form.konsumsi" type="number" step="0.01" class="form-control form-control-sm"> <br>
                                                </div>
                                            </div>
                                            <hr>
                                        
                                        
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_data_produksi/";
const ADD_URL_PRODUKSI = URL_APP + "api/v1/statistik_ketapang_master_komoditi/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const FILE_LOAD = URL_APP + "uploads/";
const URL_SERVER = URL_APP;

import Autocomplete from 'vue2-autocomplete-js';

export default {
    components: { Autocomplete },
    data() {
        return {
            data_load : false,
            form : {
                id : '',
                kecamatan_id : '',
                produksi_kotor : 0,
                master_komoditi_id : '',
                createBy : '',
                createAt : '',
                keterangan : '',
                jml_penduduk : 0,
                konsumsi : 0,
                bln : '',
                thn : '',
            },
            id :'',
            cek_load_data : true,
            cek_edit : false,
            cek_Add : false,
            cek_disabled : false,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn: [],
            list_bln: [],
            list_master_komoditi_id: [],
            
            object_data : {
                Pengeluaran_GKG_benih: 0,
                Pengeluaran_GKG_pakan_ternak: 0,
                Pengeluaran_GKG_susut: 0,
                Penggunaan_Bersa_industri_nm: 0,
                Penggunaan_Bersa_pakan_ternak: 0,
                Penggunaan_Bersa_susut: 0,
                Pengeluaran_GKG_BBI : 0,
                bersih: 0,
                jml_penduduk: 0,
                konsumsi: 0,
                produksi_kotor: 0
            },


            page_first: 1,
            page_last: 0,
            cari_value: "",

            URL : URL_SERVER,
            token : localStorage.token,
        }
    },
    methods: {
        getView: function() {

            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    kecamatan_id: this.form.kecamatan_id,
                    master_komoditi_id: this.form.master_komoditi_id,
                    bln: this.form.bln,
                    thn: this.form.thn,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                    this.list_data = res_data;
                    this.cek_load_data = false;


                    // this.object_data = res_data[0];
                    if (res_data.length <= 0) {
                        this.form.id = ''
                        console.log('data kosong');
                        this.cek_disabled = false;
                        this.object_data = {
                            Pengeluaran_GKG_benih: 0,
                            Pengeluaran_GKG_pakan_ternak: 0,
                            Pengeluaran_GKG_susut: 0,
                            Penggunaan_Bersa_industri_nm: 0,
                            Penggunaan_Bersa_pakan_ternak: 0,
                            Penggunaan_Bersa_susut: 0,
                            Pengeluaran_GKG_BBI : 0,
                            bersih: 0,
                            jml_penduduk: 0,
                            konsumsi: 0,
                            produksi_kotor: 0
                        }


                      
                    } else {
                        console.log('data ditemukan');
                        this.cek_disabled = true;
                        this.form.id = res_data[0].id;
                        this.object_data = {
                            Pengeluaran_GKG_benih: res_data[0].Pengeluaran_GKG_benih,
                            Pengeluaran_GKG_pakan_ternak: res_data[0].Pengeluaran_GKG_pakan_ternak,
                            Pengeluaran_GKG_susut: res_data[0].Pengeluaran_GKG_susut,
                            Penggunaan_Bersa_industri_nm: res_data[0].Penggunaan_Bersa_industri_nm,
                            Penggunaan_Bersa_pakan_ternak: res_data[0].Penggunaan_Bersa_pakan_ternak,
                            Penggunaan_Bersa_susut: res_data[0].Penggunaan_Bersa_susut,
                            Pengeluaran_GKG_BBI: res_data[0].Pengeluaran_GKG_BBI,
                            bersih: res_data[0].bersih,
                            jml_penduduk: res_data[0].jml_penduduk,
                            konsumsi: res_data[0].konsumsi,
                            produksi_kotor: res_data[0].produksi_kotor,
                        };

                        this.form.produksi_kotor = res_data[0].produksi_kotor;
                        this.form.id = res_data[0].id;
                        this.form.keterangan = res_data[0].keterangan;
                        this.form.jml_penduduk = res_data[0].jml_penduduk;
                        this.form.konsumsi = res_data[0].konsumsi;
                        this.form.bln = res_data[0].bln;
                        this.form.thn = res_data[0].thn;
                    }

                   // console.log(this.object_data)
            });
        },

        addData: function() {

            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            this.form = {
                id : data.id,
                kecamatan_id : data.kecamatan_id,
                produksi_kotor : data.produksi_kotor,
                master_komoditi_id : data.master_komoditi_id,

                createBy : data.createBy,
                createAt : data.createAt,
                keterangan : data.keterangan,
                jml_penduduk : data.jml_penduduk,
                konsumsi : data.konsumsi,
                bln : data.bln,
                thn : data.thn,
            };
        },

        Chk_Add : function(){
            if (this.form.kecamatan_id == null || this.form.kecamatan_id == '' || this.form.kecamatan_id == undefined  ) {
                this.cek_Add = false;
            } else {
                this.cek_Add = true;
            }
        },
        produksi_final : function(data){
            var f_Pengeluaran_GKG_benih = data.produksi_kotor * data.Pengeluaran_GKG_benih/100;
            var f_Pengeluaran_GKG_pakan_ternak = data.produksi_kotor * data.Pengeluaran_GKG_pakan_ternak/100;
            var f_Pengeluaran_GKG_susut = data.produksi_kotor * data.Pengeluaran_GKG_susut/100;

            var f_Pengeluaran_GKG_BBI = data.produksi_kotor * data.Pengeluaran_GKG_BBI/100;
            var f_Penggunaan_Bersa_pakan_ternak = data.produksi_kotor * data.Penggunaan_Bersa_pakan_ternak/100;
            var f_Penggunaan_Bersa_industri_nm = data.produksi_kotor * data.Penggunaan_Bersa_industri_nm/100;
            var f_Penggunaan_Bersa_susut = data.produksi_kotor * data.Penggunaan_Bersa_susut/100;

            var f_produksi_GKG = data.produksi_kotor-f_Pengeluaran_GKG_benih-f_Pengeluaran_GKG_pakan_ternak-f_Pengeluaran_GKG_susut-f_Pengeluaran_GKG_BBI-f_Penggunaan_Bersa_pakan_ternak-f_Penggunaan_Bersa_industri_nm-f_Penggunaan_Bersa_susut;

            var f_produksi_bersih = f_produksi_GKG * data.bersih/100;

            return {
                Pengeluaran_GKG_benih : f_Pengeluaran_GKG_benih.toFixed(2),
                Pengeluaran_GKG_pakan_ternak : f_Pengeluaran_GKG_pakan_ternak.toFixed(2),
                Pengeluaran_GKG_susut : f_Pengeluaran_GKG_susut.toFixed(2),
                Pengeluaran_GKG_BBI : f_Pengeluaran_GKG_BBI.toFixed(2),

                Penggunaan_Bersa_pakan_ternak : f_Penggunaan_Bersa_pakan_ternak.toFixed(2),
                Penggunaan_Bersa_industri_nm : f_Penggunaan_Bersa_industri_nm.toFixed(2),
                Penggunaan_Bersa_susut : f_Penggunaan_Bersa_susut.toFixed(2),

                produksi_GKG : f_produksi_GKG.toFixed(2),
                produksi_bersih : f_produksi_bersih.toFixed(2),
            }

        },


        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },
        ke_alamat : function(data){
            window.open(data);
        },

    // ================== TAMBAHAN ====================

        getProduksi : function(){
            fetch(ADD_URL_PRODUKSI, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                this.list_master_komoditi_id = res_data;
                this.form.master_komoditi_id = res_data[0].master_komoditi_id;
                this.getTahun();
            });
        },
        getTahun : function(){
            fetch(ADD_URL_DATE + "thn", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_thn = res_data;
                 this.getBln();
            });
        },
        getBln : function(){
            fetch(ADD_URL_DATE + "bln", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                 this.list_bln = res_data;
                 this.getView();
            });
        },
        pembulatan : function(a, b){
            var data = a * b/100;
            var hasil = data.toFixed(2);
            return hasil;
        },
        pembulatanX : function(a, b){
            var data = a * b/100;
            return data;
        },
    // ================== TAMBAHAN ====================

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.nama_kecamatan}</b></span>
            <span style='font-size:80%'>${data.nama_kabupaten}</span>
            `
        },
        getAuto : function(obj){
            this.form.kecamatan_id = obj.kecamatan_id;
            this.getView();
            // console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================


    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
    // ================== PAGINASI ====================
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;


        this.getProduksi();
        

        

        var d = new Date();
        // console.log(d.getMonth())
        this.form.thn = d.getFullYear();
        this.form.bln = d.getMonth();


    },

}
</script>